class HeaderMenu extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.header = document.querySelector('.header');
    this.summary = this.mainDetailsToggle.querySelector('summary');

    this.addMenuEventListeners();

    document.addEventListener('focusin', this.onFocusChange.bind(this));
    document.addEventListener('click', this.onDocumentClick.bind(this));
  }

  addMenuEventListeners() {
    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));

    document.querySelectorAll('.header-menu summary').forEach((menuItem) => {
      if (menuItem !== this.summary) {
        menuItem.addEventListener(
          'mouseenter',
          this.onOtherMenuItemHover.bind(this)
        );
        menuItem.addEventListener(
          'focusin',
          this.onOtherMenuItemHover.bind(this)
        );
      }
    });
  }

  onMouseEnter() {
    // Close all other open menus
    document.querySelectorAll('details[open]').forEach((details) => {
      if (details !== this.mainDetailsToggle) {
        details.removeAttribute('open');
        details.querySelector('summary').setAttribute('aria-expanded', false);
      }
    });

    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.summary.setAttribute('aria-expanded', true);
      this.onToggle();
    }
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
    }
  }

  onMouseLeave(event) {
    this.closeTimeout = setTimeout(() => {
      this.close();
      this.onToggle();
    }, 100);
  }

  onOtherMenuItemHover() {
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.close();
      this.onToggle();
    }
  }

  onFocusChange(event) {
    if (!this.header.contains(event.target)) {
      this.close();
      this.onToggle();
    }
  }

  onDocumentClick(event) {
    if (!this.header.contains(event.target)) {
      this.close();
      this.onToggle();
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.onToggle();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        '--header-bottom-position-desktop'
      ) !== ''
    )
      return;

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);